import React from 'react';
import { Box, Typography } from '@mui/material';

interface QuestionTitleBarProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  timeRemaining: number;
  testColor: string;
  lightenColor: (color: string, amount: number) => string;
  seriesName?: string;
  grade?: string;
  subject?: string;
}

const QuestionTitleBar: React.FC<QuestionTitleBarProps> = ({
  currentQuestionIndex,
  totalQuestions,
  timeRemaining,
  testColor,
  lightenColor,
  seriesName,
  grade,
  subject
}) => {
  // Format time as MM:SS
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };
  return (
    <Box sx={{ 
      p: 3, 
      pb: 2, 
      background: `linear-gradient(135deg, ${testColor} 0%, ${lightenColor(testColor, -0.2)} 100%)`, 
      color: 'white' 
    }}> 
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}> 
        {/* Left side - Series name and grade-subject */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 400, lineHeight: 1 }}> 
            {seriesName || 'Test Series'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 400 }}> 
            {grade && subject ? `${grade} - ${subject}` : 'Grade - Subject'}
          </Typography>
        </Box>
        
        {/* Center - Question number in circle */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          width: 48,
          height: 48,
          borderRadius: '50%',
          backgroundColor: 'rgba(255,255,255,0.2)',
          border: '2px solid rgba(255,255,255,0.3)'
        }}>
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 'bold', 
              color: 'white',
              fontSize: '1.1rem'
            }} 
          >
            {currentQuestionIndex + 1}
          </Typography>
        </Box>
        
        {/* Right side - Timer in MM:SS format */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}> 
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 'bold', 
              color: 'white',
              fontFamily: 'monospace',
              fontSize: '1.2rem'
            }} 
          > 
            {formatTime(timeRemaining)}
          </Typography> 
        </Box> 
      </Box> 
    </Box>
  );
};

export default QuestionTitleBar;